<template>
  <aside
    id="modal-libris-image"
    ref="aside"
    class="modal modal--default micromodal-slide"
    aria-hidden="true"
    :modal-open="modalOpen"
  >
    <div class="modal__overlay" tabindex="-2" data-micromodal-close>
      <div
        class="panel__container modal__container w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-colors-filters-title"
      >
        <div class="grid-wrapper">
          <header class="panel__header modal__header grid-row">
            <div class="col-12 lg:col-4">
              <h4 class="h4 modal__title">
                3form /
                <span class="lg:block">{{
                  displayName.replace('3FORM-', '').trim()
                }}</span>
              </h4>
              <a
                role="button"
                aria-roledescription="button"
                class="vue-button button w-full lg:w-auto hidden lg:block"
                :href="bitreelLink"
                target="_blank"
                @click="sendAdobeConfiguratorClick"
              >
                <span class="button__content">
                  Open in Configurator
                  <svg class="icon icon-cta">
                    <use xlink:href="#icon-cta" />
                  </svg>
                </span>
              </a>
              <a
                :href="`${link.replace('500x500', '2000x2000')}`"
                download
                target="blank"
                class="link-download-image link-download-image--black mt-6"
                @click="sendAdobeDownloadClick"
              >
                <svg
                  class="icon icon-download icon--start align-bottom"
                  aria-hidden="true"
                  focusable="false"
                >
                  <use xlink:href="#icon-download" />
                </svg>
                <span class="a a--letter-spacing-sm">Download Comp Image</span>
              </a>
            </div>
            <div class="col-12 first-xs lg:col-8 lg:last-xs">
              <div
                class="bg-transparent text-center md:mr-6 flex items-center justify-center"
              >
                <img
                  v-if="orientation && orientation.value !== `Portrait`"
                  class="w-full lg:w-auto"
                  :src="link.replace('500x500x', '2000x2000')"
                  :srcset="
                    `
                  ${link.replace('500x500', '2000x2000')} 2000w,
                  ${link.replace('500x500', '1500x1500')} 1500w,
                  ${link.replace('500x500', '640x640')} 640w,
                  ${link.replace('500x500', '480x480')} 480w,
                  ${link.replace('500x500', '320x320')} 320w`
                  "
                  sizes="(min-width: 66.66em) 66.66vw"
                />
                <img
                  v-else
                  oldclass="w-full max-w-md md:w-auto md:max-w-full md:h-90v md:max-h-md lg:max-h-lg"
                  class="w-full max-w-md lg:w-auto lg:max-w-full lg:h-90v lg:max-h-lg"
                  :src="link.replace('500x500', '1200x1200')"
                  :srcset="
                    `
                  ${link.replace('500x500', '1200x1200')} 800w,
                  ${link.replace('500x500', '800x800')} 640w,
                  ${link.replace('500x500', '640x640')} 480w,
                  ${link.replace('500x500', '320x320')} 320w`
                  "
                  sizes="(min-width: 66.66em) 33.33vw, 50vw"
                />
              </div>
            </div>
            <button
              class="panel__button modal__close js-close-panel"
              aria-label="Close modal"
              data-micromodal-close
            >
              <svg class="icon icon-close-circle">
                <use xlink:href="#icon-close-circle" />
              </svg>
            </button>
          </header>
          <div class="panel">
            <div class="panel__content modal__content">
              <!-- First row is data from Libris -->
              <div class="md:mr-4 grid-row">
                <!-- Orientation Tag -->
                <div
                  v-if="orientation"
                  class="h-auto col-6 lg:col-3 content-card"
                >
                  <div class="content-card__inner">
                    <div class="content-card__content">
                      <h4 class="content-card__title mb-2">
                        Orientation
                      </h4>
                      <p class="p">
                        {{ orientation.value }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Scale Tag -->
                <div
                  v-if="scale"
                  class="h-auto col-6 lg:col-3 content-card content-card--border-grey"
                >
                  <div class="content-card__inner">
                    <div class="content-card__content">
                      <h4 class="content-card__title mb-2">
                        Scale
                      </h4>
                      <div v-if="scale.value === 'mural'" class="p">
                        <div>
                          <img
                            src="/static/icons/SVG/icon-single-panel-dark.svg"
                            alt="Single Panel Image"
                          />
                          <p class="mb-2">
                            Single Panels (48"x 96")
                          </p>
                        </div>
                        <div class="p">
                          <img
                            src="/static/icons/SVG/icon-mural-panel-dark.svg"
                            alt="Single Panel Image"
                          />
                          <p class="mb-2">
                            Multi panel (up to 192" x 96")
                          </p>
                        </div>
                      </div>

                      <div v-if="scale.value === 'single_panel'">
                        <div
                          class="p flex items-center flex-wrap md:flex-no-wrap"
                        >
                          <img
                            src="/static/icons/SVG/icon-single-panel-dark.svg"
                            alt="Single Panel Image"
                            class="mr-4"
                          />
                          <p class="mt-2">
                            Single Panels (48" x 96")
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Tags Custom Meta -->
                <div
                  v-if="metaTags"
                  class="h-auto col-6 lg:col-3 content-card content-card--border-grey"
                >
                  <div class="content-card__inner">
                    <div class="content-card__content">
                      <h4 class="content-card__title mb-2">
                        Tags
                      </h4>
                      <p class="label mb-4 leading-normloose text-grey-md-dark">
                        <a
                          :aria-label="
                            `update the app search term to be ${item}`
                          "
                          @click="
                            searchTerm !== item
                              ? handleTagClick($event, item)
                              : () => {}
                          "
                          v-for="(item, index) in metaTags.value"
                          :key="`${item}${index}`"
                        >
                          <span
                            :class="searchTerm !== item ? `vue-color` : ''"
                            >{{ item }}</span
                          >
                          <span v-if="index !== metaTags.value.length - 1">
                            /
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="closeModal" class="modal__bg" data-micromodal-close />
  </aside>
</template>
<script>
import { eventBus } from '../../shared/event-bus';
import {
  handleFileDownloadEvent,
  handleAdobeNavEvent,
  analyticsCtaDataObject,
  analyticsLabelFromString,
} from '../../../helpers/adobe-analytics';

const ANALYTICS_PLACEMENT = 'Digital Print Library';

export default {
  props: [
    'link',
    'customMetadata',
    'tags',
    'displayName',
    'modalOpen',
    'searchTerm',
  ],
  computed: {
    orientation() {
      return this.customMetadata.filter(
        ({ name }) => name === 'Orientation'
      )[0];
    },
    scale() {
      return this.customMetadata.filter(({ name }) => name === 'scale')[0];
    },
    metaTags() {
      const transformedTags = this.tags
        ? this.tags.split(',').reduce((acc, currVal) => {
            if (currVal === '') return acc;
            let newAcc = [...acc, currVal.trim()];
            return newAcc;
          }, [])
        : [];
      if (transformedTags.length > 0) {
        return { name: 'tags', value: transformedTags };
      }
      return null;
    },
    bitreelLink() {
      const url = new URL(
        '/digital-printing/configure',
        window.location.origin
      );
      // link is defaulted to 500x500, bitreel needs the larger image
      url.searchParams.set(
        'image_link',
        this.link.replace('500x500', '2000x2000')
      );
      if (!!this.orientation) {
        url.searchParams.set('orientation', this.orientation.value);
      }
      if (!!this.scale) url.searchParams.set('scale', this.scale.value);
      return url.toString();
    },
  },
  methods: {
    // clicking a close trigger closes every MicroModal instance bound to it
    close() {
      this.$refs.closeModal.click();
    },
    updateSearchTerm(data) {
      eventBus.updateSearchTerm(data);
      this.close();
    },
    handleTagClick(event, tag) {
      handleAdobeNavEvent({
        navString: `INP|${ANALYTICS_PLACEMENT}|Tag ${tag}`,
        event,
      });
      this.updateSearchTerm(tag);
    },
    sendAdobeConfiguratorClick(event) {
      handleAdobeNavEvent({
        navString: `NAV|${ANALYTICS_PLACEMENT}|Open In Configurator`,
        destinationUrl: this.bitreelLink,
        target_blank: true,
        event,
      });
    },
    sendAdobeDownloadClick() {
      const downloadUrl = this.link.replace('500x500', '2000x2000');
      const file_name = analyticsLabelFromString(this.displayName);
      const downloadData = {
        file_format: 'JPG',
        file_name,
        link_url: downloadUrl,
        link_type: 'IMAGE',
        placement: ANALYTICS_PLACEMENT,
      };

      handleFileDownloadEvent(analyticsCtaDataObject(downloadData));
    },
  },
};
</script>

<style scoped>
.vue-color {
  cursor: pointer;
  transition: color 300ms ease-in;
}

.vue-color:hover {
  color: #222;
}
</style>
